export const uploadMediaUS = {
  maxLimitTime: 'The time limit is only 2 minutes per video',
}

export const uploadMediaES = {
  maxLimitTime: 'El tiempo limite es de solo 2 minutos por video',
}
